import React, { useEffect, useRef } from 'react';

import styles from './styles.module.scss';

const RoundCountdown = ({ secondsRemain, endDate, seconds }) => {
  const LENGTH_OF_CIRCLE = 100;
  const circleRef = useRef(null);

  const animateCircle = () => {
    const currentTime = Date.now();
    const differenceInSec = seconds - (endDate - currentTime) / 1000;
    const differenceInPercent = (differenceInSec / seconds) * 100;
    const offset = (differenceInPercent / 100) * LENGTH_OF_CIRCLE;
    if (circleRef.current) {
      circleRef.current.style.strokeDashoffset = `${offset}px`;
    }
    requestAnimationFrame(animateCircle);
  };
  useEffect(() => {
    animateCircle();
  });
  return (
    <div className={styles.countdown}>
      <span className="text-s">{secondsRemain}</span>
      <svg width={50} height={50}>
        <circle r="16" cx="50%" cy="50%" ref={circleRef}></circle>
      </svg>
    </div>
  );
};

export default RoundCountdown;
